import { OnboardingInfos } from './account.models';

export const ONBOARDING_SLIDES: {
  Reload: OnboardingInfos;
  Fluidite: OnboardingInfos;
  Nutriscore: OnboardingInfos;
  Greenscore: OnboardingInfos;
  Booking: OnboardingInfos;
  Favorite: OnboardingInfos;
  Order: OnboardingInfos;
  AntiGaspi: OnboardingInfos;
} = {
  Reload: {
    key: 'RELOAD',
    order: 1,
    svgPath: '/assets/svg/onboarding/reload.svg',
  },
  Fluidite: {
    key: 'FLUIDITE',
    order: 2,
    svgPath: '/assets/svg/onboarding/affluence.svg',
  },
  Nutriscore: {
    key: 'NUTRISCORE',
    order: 3,
    svgPath: '/assets/svg/onboarding/nutriscore.svg',
  },
  Greenscore: {
    key: 'GREENSCORE',
    order: 4,
    svgPath: '/assets/svg/onboarding/greenscore.svg',
  },
  Booking: {
    key: 'BOOKING',
    order: 5,
    svgPath: '/assets/svg/onboarding/booking.svg',
  },
  Favorite: {
    key: 'FAVORITE',
    order: 6,
    svgPath: '/assets/svg/onboarding/favorite.svg',
  },
  Order: {
    key: 'ORDER',
    order: 7,
    svgPath: '/assets/svg/onboarding/order.svg',
  },
  AntiGaspi: {
    key: 'ANTIGASPI',
    order: 0,
    imgPath: '/assets/svg/onboarding/antigaspi.png',
  },
};

export const NB_SLIDES_TO_DISPLAY = 3;
